import { SplashScreen } from "@westpierstudio/luma/game";
import { OryxGame } from "@westpierstudio/core-module-oryx/game";
import { LuckyWealthCatGameController } from "game/LuckyWealthCatGameController";
import { KSGLoadingScreen } from "@westpierstudio/core-module-oryx/game/KSGLoadingScreen";
import { LuckyWealthCatGameModel } from "./LuckyWealthCatGameModel";
import { LuckyWealthCatGameView } from "./LuckyWealthCatGameView";
import { LuckyWealthCatGameClient } from "game/LuckyWealthCatGameClient";
import { GameServices } from "./GameServices";


export class LuckyWealthCatGame extends OryxGame {

    constructor(
        protected override services: GameServices,
        protected override gameModel: LuckyWealthCatGameModel,
        protected override gameView: LuckyWealthCatGameView,
        protected override gameController: LuckyWealthCatGameController,
        protected override loadingScreen: KSGLoadingScreen,
        protected override splashScreen: SplashScreen | undefined,
        protected override gameClient: LuckyWealthCatGameClient
    ) {
        super(
            services,
            gameModel,
            gameView,
            gameController,
            loadingScreen,
            splashScreen,
            gameClient,
            {realTime3D: true}
        );
    }

    protected override startApplication() {
        super.startApplication();
        if (!this._initialiseError) {
            this.services.application.renderer.backgroundColor = 0x000000;
        }
    }

    override onSupportingResourcesLoaded() {

        const {layout, resources} = this.services;

        const padding = resources.getSetting(`bucketPadding`);

        if (padding) {

            const applyPadding = () => {
                layout.setPadding(padding[layout.orientation]);
            };

            layout.onReorient.add(applyPadding);
            applyPadding();
        }
    }
}